import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { selectBandwidthEffective4kCodecExp } from '../../../user/selectors';

export const useShouldShowBandwidthTumbler = () => {
    const bandwidthEffective4kCodecExp = useSelector(selectBandwidthEffective4kCodecExp);
    const { pathname } = useLocation();
    const isOnCallPage = pathname.startsWith('/j/');

    return bandwidthEffective4kCodecExp && !isOnCallPage;
};
